
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

//import {Echarts} from '../assets/lib/echarts.min.js'

//import MyCell from "components/mycell"
export default {
    name: 'show',
    components: {
        Swiper,
SwiperItem,
GroupTitle,
XButton,
Divider
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },

}



// WEBPACK FOOTER //
// ./src/components/show.vue